
import { UserSubmittableDataRecord } from './user-submittable-data-record';

export class InjectionDataRecord extends UserSubmittableDataRecord {
  InjectionDate: Date;
  InjectionPressureAveragePsig: number;
  InjectionPressureMaxPsig: number;
  VolumeInjectedBbl: number;
  TotalGasVolumeMcf: number;
  AnnulusPressureNumReadings: number;
  AnnulusPressureMinPsig: number;
  AnnulusPressureMaxPsig: number;
  CurrentInjectionIntervalTop: number;
  CurrentInjectionIntervalBottom: number;
  Formation: number;
  DepthTubingPacker: number;
  InjectedFluidsOtherSources: boolean;
  InjectionThrough: string;
  FractionSaltWater: number;
  FractionFreshWater: number;
  FractionFractureWaterFlowBack: number;
  FractionNorm: number;
  FractionCo2: number;
  FractionNaturalGas: number;
  FractionH2s: number;
  FractionPolymer: number;
  FractionSteam: number;
  FractionAir: number;
  FractionNitrogen: number;
  FractionOther: number;
  OtherDesc: string;
  InjectionEndDate: Date;
  DateRowAdded: Date;
  MaxDayInjGasRate: number;
  MaxDayInjLiqRate: number;

  public get EndDate() {

    var startDate : Date = new Date(this.InjectionDate);

    startDate.setMonth(startDate.getMonth() + 1);

    return startDate;
  }

  FormationIds: Array<number>;

}
